import React from "react";
import ReactDOM from "react-dom";

import Calculator from "./components/Calculator";

ReactDOM.render(<Calculator />, document.getElementById("main"));
